import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { QuoteProvider } from "@/context/QuoteContext";
import { AuthProvider } from "@/context/AuthContext";
import { Header } from "@/components/Header";
import { Footer } from "@/components/Footer";
import { QuoteDrawer } from "@/components/QuoteDrawer";
import Home from "@/pages/Home";
import Catalog from "@/pages/Catalog";
import ProductDetail from "@/pages/ProductDetail";
import Brands from "@/pages/Brands";
import BrandPage from "@/pages/BrandPage";
import HowToOrder from "@/pages/HowToOrder";
import Contact from "@/pages/Contact";
import AdminPage from "@/pages/admin/AdminPage";
import Account from "@/pages/Account";
import AuthCallback from "@/pages/AuthCallback";

function AppRouter() {
  const location = useLocation();
  if (location.hash?.includes("session_id=")) return <AuthCallback />;
  return (
    <>
      <Header />
      <main>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/catalog" element={<Catalog />} />
          <Route path="/products/:id" element={<ProductDetail />} />
          <Route path="/brands" element={<Brands />} />
          <Route path="/brands/:slug" element={<BrandPage />} />
          <Route path="/how-to-order" element={<HowToOrder />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/admin/*" element={<AdminPage />} />
          <Route path="/account" element={<Account />} />
        </Routes>
      </main>
      <Footer />
      <QuoteDrawer />
    </>
  );
}

export default function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <QuoteProvider>
            <AppRouter />
            <Toaster position="top-right" richColors />
          </QuoteProvider>
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}
